<template>
    <div class="container">
                  <div class="detail-card">
                    <h6 style="margin-left:5px;">Payment Information</h6>
                    <div class="card card-colord-01 card-colord-pad">
                      <p><b>Bank Information</b></p>
                      <p class="p-tiny-info">Set up your Bank Details for direct Transfers</p>
                      <p v-if="sellpoint.business_bank_details && (Object.keys(sellpoint.business_bank_details).length == 0)" style="color:#ff0000">
                        You have not set up your bank yet
                      </p>
                      <a class="btn sp-button-02 sp-button-sm" @click="setMenuTabInnerView('setBankDetails')" style="float: right;">SET</a>
                      <div class="clearfix"></div>
                      <div v-if="menu_tab_inner_view.setBankDetails || menu_tab_inner_view.editBankDetails">
                          <h6 class="margin-t-40">Set Bank Details</h6>
                          <p>This account is where your payout would be sent to.</p>
                          <div>
                            <form class="sp-form" style="padding-left:0" v-if="sellpoint.business_bank_details.length == 0 || menu_tab_inner_view.editBankDetails">
                              <div style="display:none;"><!--pause--usage-->
                                <label><b>Bank Name:</b>
                                  <input type="text" class="form-control" v-model="sellpoint.business_bank_details.bank_name" />
                                </label>
                                <label><b>Account Holder's Name:</b>
                                  <input type="text" class="form-control" v-model="sellpoint.business_bank_details.bank_account_name" />
                                </label>
                                <label><b>Account No:</b>
                                    <input type="number" class="form-control" v-model="sellpoint.business_bank_details.bank_account_number" />
                                </label>
                                <p class="tiny-p">your details are secured</p>
                                <div class="loading-sm" v-if="action_loading"></div>
                                <p style="color:#ff0000;">{{data_processing_message}}</p>
                                <button :disabled="disable_btn" type="button" class="btn" @click="setBankDetails">Save Bank Details</button>
                              </div>
                              <div><!--use--this-for-now-->
                                <label><b>Bank Name:</b>
                                  <select class="form-control" v-model="ravepay_sba.account_bank">
                                    <option :value="undefined">Select your bank</option>
                                    <option v-for="bank in ravepay_bank_list" :value="bank.Code" :key="bank.code">{{bank.Name}}</option>
                                  </select>
                                  <br>
                                  <label><b>Account No:</b>
                                    <input type="number" class="form-control" v-model="ravepay_sba.account_number" />
                                  </label>
                                  <!-- <label v-if="!sellpoint.business_contact_email || (sellpoint.business_contact_email == '')"> -->
                                  <label>
                                    <b>Contact Email:</b>
                                    <input type="text" class="form-control" v-model="sellpoint.business_contact_email" />
                                  </label>
                                  <!-- <label v-if="!sellpoint.business_contact_phone || (sellpoint.business_contact_phone == '')"> -->
                                  <label>
                                    <b>Contact Phone Number:</b>
                                    <input type="text" class="form-control" v-model="sellpoint.business_contact_phone" />
                                  </label>
                                </label>
                                <p class="tiny-p"></p>
                                <div class="loading-sm" v-if="action_loading"></div>
                                <p style="color:#ff0000;">{{data_processing_message}}</p>
                                <button :disabled="disable_btn" class="btn" type="button" @click="setBankDetailsRavePay">Save Bank Details</button>
                              </div>
                            </form>
                              <div v-else>
                              <p><b>Bank:</b> {{sellpoint.business_bank_details.bank_name}}</p>
                              <p><b>Account Holder's Name:</b> {{sellpoint.business_bank_details.bank_account_name}}</p>
                              <p><b>Account No:</b> {{sellpoint.business_bank_details.bank_account_number}}</p>
                              <p class="tiny-p">you can edit or change bank details</p>
                              <button class="btn" @click="setMenuTabInnerView('editBankDetails','')">Edit Bank Details</button>
                              </div>
                              <a class="btn sp-button-02 sp-button-sm" @click="setMenuTabInnerView('')" style="float: right;">close</a>
                              <div class="clearfix"></div>
                          </div>
                      </div>
                    </div>
                    <div class="card card-out-colord-pad mt1">
                      <p><b>Processing Fees Account</b></p>
                      <!-- <p class="p-tiny-info">Set how you would want to settle your proccessing fees</p> -->
                      <p v-if="(sellpoint.business_processing_fee_balance >= 0)" class="sp-app-default-color">Processing Fee Balance: <b>
                        <span v-if="sellpoint.business_processing_fee_balance < 1000" style="color:#ff0000;">{{sellpoint.business_processing_fee_balance}}</span>
                        <span v-else><small>&#8358;</small>{{sellpoint.business_processing_fee_balance}}</span>
                      </b></p>
                      <a class="btn sp-button-02 sp-button-sm" @click="setMenuTabInnerView('viewProcessingFees')" style="float: right;">Set</a>
                      <div class="clearfix"></div>
                      <div v-if="menu_tab_inner_view.viewProcessingFees || menu_tab_inner_view.addProcessingFees">
                        <div>
                          <h6>Processing Fee Balance</h6>
                          <p>To keep receiving Buyers Order transfers <b>*directly*</b> to your Bank Account, please ensure your Processing Fee
                          is not zero or below</p>
                          <p>Processing Fee Balance: <b>
                            <span v-if="sellpoint.business_processing_fee_balance < 1000" style="color:#ff0000;">{{sellpoint.business_processing_fee_balance}}</span>
                            <span v-else>{{sellpoint.business_processing_fee_balance}}</span>
                          </b></p>
                          <p style="color:#ff0000;" v-if="(sellpoint.business_processing_fee_balance < 2000) && (sellpoint.business_processing_fee_balance > 0)">
                            Processing Fee is running low
                          </p>
                          <p style="color:#ff0000;" v-if="sellpoint.business_processing_fee_balance == 0">
                            Processing Fee is low
                          </p>
                          <p style="color:#ff0000;" v-if="sellpoint.business_processing_fee_debt > 0">
                            Processing Fee is low and you are owing processing fee charge of <span style="font-weight: bolder"> -{{sellpoint.business_processing_fee_debt}}</span>
                          </p>
                          <a v-if="!menu_tab_inner_view.addProcessingFees" class="btn sp-button-02 sp-button-md" @click="setMenuTabInnerView('addProcessingFees')" style="float: right;">Add Processing Fees</a>
                          <div v-if="menu_tab_inner_view.addProcessingFees">
                            <form class="sp-form">
                              <div class="form-group">
                                <label>Enter Amount</label>
                                <input v-model="processing_fee.amount" type="text" class="form-control">
                              </div>
                              <div class="form-group">
                                <p style="color:#4617c7;">{{data_processing_message}}</p>
                                <p style="color:#ff0000;">{{data_error_message}}</p>
                                <div class="loading-sm" v-if="action_loading"></div>
                                <button type="button" :disabled="disable_btn" class="btn sp-button-02 sp-button-md" @click="addtoProcessingFee()">Add</button>
                                <button type="button" class="btn sp-button-02 sp-button-md" @click="setComponent('reset-edit','')">Cancel</button>
                              </div>
                            </form>
                          </div>
                        </div>
                        <div class="clearfix"></div>
                        <a class="btn sp-button-02 sp-button-sm" @click="setMenuTabInnerView('')" style="float: right;">close</a>
                        <div class="clearfix"></div>
                      </div>
                    </div>
                    <div class="card card-colord-01 card-colord-pad mt1">
                      <p><b>Processing Fees Settings</b></p>
                      <p class="p-tiny-info">Set how you would want to settle your proccessing fees</p>
                      <a class="btn sp-button-02 sp-button-sm" @click="setMenuTabInnerView('setProcessingFees')" style="float: right;">Set</a>
                      <div class="clearfix"></div>
                      <div v-if="menu_tab_inner_view.setProcessingFees || menu_tab_inner_view.setProcessingFees">
                        <h6>Set Processing Fee Option</h6>
                        <p>Each sale of an Item attracts a processing fee. The processng fee could
                          be paid by you as you set your product, or by your customers as they buy. 
                          Processing Fees are subject to change.</p>
                        <p style="color:#363535">Processing Fee is set to: 13% of your product Item</p>
                        <div v-if="action_loading" class="loading-sm"></div>
                        <p class="info info-processing">{{data_processing_message}}</p>
                        <span v-if="sellpoint.business_processing_fee_pay_status == 3">
                          <p><b>Status:</b> Paid by Me </p>
                          <p class="tiny-p">Switch Pay to your Custmers, notice this would increase the amount they pay on checkout</p>
                          <button :disabled="disable_btn" class="btn sp-button-02 sp-button-md" @click="switchProcessingFee(4)">Switch Pay to your Custmers</button>
                        </span>
                        <span v-if="sellpoint.business_processing_fee_pay_status == 4">
                          <p><b>Status:</b> Paid by My Customers</p>
                          <p class="p-tiny-info">Switch Pay back to you, and let your Customers enjoy to pay only for their orders on checkout</p>
                          <button :disabled="disable_btn" class="btn sp-button-02 sp-button-md" @click="switchProcessingFee(3)">Switch Pay Back to Me</button>
                        </span>
                        <br><br>
                        <a class="btn sp-button-02 sp-button-sm" @click="setMenuTabInnerView('')" style="float: right;">close</a>
                        <div class="clearfix"></div>
                      </div>
                    </div>
                    <div class="card card-out-colord-pad mt1">
                      <p><b>Set your Payment Collection Gateway</b></p>
                      <div class="card card-flat-pad">
                        <p>Ravepay  - Direct Personal Integration</p>
                        <p class="p-tiny-info">You would be directed to Ravepay Website to create and set up your account</p>
                        <a class="btn sp-button-02 sp-button-sm" @click="setMenuTabInnerView('setRavepay')" style="float: right;">SET</a>
                        <div class="clearfix"></div>
                        <div v-if="menu_tab_inner_view.setRavepay">
                          <h6 class="margin-t-40">Set Ravepay Details</h6>
                          <p>This account is where your payout would be sent to.</p>
                          <div v-if="sellpoint.business_ravepay_accounts && (Object.keys(sellpoint.business_ravepay_accounts).length > 0)">
                            <p>Accounts on Ravepay</p>
                            <div class="card" v-for="pg in sellpoint.business_ravepay_accounts" :key="pg.account_email">
                              {{pg.account_email}}
                            </div>
                          </div>
                          <p v-else class="info-processing">No Ravepay Account set yet</p>
                          <br><br>
                          <p><a href="https://ravepay.co" target="_blank">Checkout Ravepay</a></p>
                          <a class="btn sp-button-02 sp-button-sm" @click="setMenuTabInnerView('')" style="float: right;">close</a>
                          <div class="clearfix"></div>
                        </div>
                      </div>
                       <div class="card card-flat-pad">
                        <p>Paystack  - Direct Personal Integration</p>
                        <p class="p-tiny-info">You would be directed to Paystack Website to create and set up your account</p>
                      </div>
                    </div>
                  </div>
                </div>
                
</template>

<style>

</style>

<script>
    import commonfunctions from "../../Resources/commonfunctions";
    export default {
        mixins: [commonfunctions],
        data () {
            return {}
        },

        methods: {
            setPage(){
              this.loading = false;
              //
              this.getRavepayBanks();
            },
        },

        components: {},

        created: function(){
            let self = this;
            localforage.getItem('xvue', function(err, value) { //quick with the callback version
                if(value != undefined) {
                    self.user = value.account.store_user;
                    self.sellpoint =  value.account.store_sellpoint.store_sellpointData;
                    self.setPage();
                }else{}
            });
        }

    }
</script>



// WEBPACK FOOTER //
// SellpointPayments.vue?a23ce348